import DynamicProviderKey from "@/model/provider/DynamicProviderKey"
import Providers from "@/model/provider/Providers"

export const providerName = function (providerKey) {
    const dynamicKey = DynamicProviderKey.extractProviderKey(providerKey)
    return Providers[dynamicKey]?.financingName
}
